import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  AiHoverIcon,
  AiIcon,
  AnalyticsHoverIcon,
  AnalyticsIcon,
  ConsultancyHoverIcon,
  ConsultancyIcon,
  ResourceHoverIcon,
  ResourceIcon,
  SoftwareHoverIcon,
  SoftwareIcon,
  UiUxHoverIcon,
  UiUxIcon
} from '../../../resources/svg';

const ServicesComponent = () => {
  const [isResource, setIsResource] = useState(false);
  const [isAi, setIsAi] = useState(false);
  const [isSoftware, setIsSoftware] = useState(false);
  const [isConsultancy, setIsConsultancy] = useState(false);
  const [isAnalytics, setIsAnalytics] = useState(false);
  const [isUiUx, setIsUiUx] = useState(false);

  const getResourceIcon = () => {
    if (isResource) {
      return (<ResourceHoverIcon />);
    } else {
      return (<ResourceIcon />);
    }
  };

  const getAiIcon = () => {
    if (isAi) {
      return (<AiHoverIcon />);
    } else {
      return (<AiIcon />);
    }
  };

  const getSoftwareIcon = () => {
    if (isSoftware) {
      return (<SoftwareHoverIcon />);
    } else {
      return (<SoftwareIcon />);
    }
  };

  const getConsultancyIcon = () => {
    if (isConsultancy) {
      return (<ConsultancyHoverIcon />);
    } else {
      return (<ConsultancyIcon />);
    }
  };

  const getUiUxIcon = () => {
    if (isUiUx) {
      return (<UiUxHoverIcon />);
    } else {
      return (<UiUxIcon />);
    }
  };

  const getAnalyticsIcon = () => {
    if (isAnalytics) {
      return (<AnalyticsHoverIcon />);
    } else {
      return (<AnalyticsIcon />);
    }
  };

  return (
    <section id="services" className="services section light-background">

      <div className="container section-title" data-aos="fade-up">
        <h2>What We Offer</h2>
        <p>With extensive experience across various sectors, we specialize delivering solutions</p>
      </div>

      <div className="container">

        <div className="row gy-4">
        <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="100">
            <Link to="/service/digital-consultancy">
              <div onMouseEnter={() => setIsConsultancy(true)}
                onMouseLeave={() => setIsConsultancy(false)} className="service-item item-pink position-relative">
                <div className="icon">
                  {getConsultancyIcon()}
                </div>
                <a href="service-details.html" className="stretched-link">
                  <h3>Digital Consultancy</h3>
                </a>
                <p>Our digital consultancy services empower businesses to navigate the complexities of digital transformation.</p>
              </div>
            </Link>
          </div>
          <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="100">
            <Link to="/service/resource-augmentation">
              <div onMouseEnter={() => setIsResource(true)}
                onMouseLeave={() => setIsResource(false)} className="service-item item-pink position-relative">
                <div className="icon">
                  {getResourceIcon()}
                </div>
                <a href="service-details.html" className="stretched-link">
                  <h3>Resource Augmentation</h3>
                </a>
                <p>Our Resource Augmentation services provide you with skilled professionals who seamlessly integrate into your existing teams.</p>
              </div>
            </Link>
          </div>
          <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="100">
            <Link to="/service/ai">
              <div onMouseEnter={() => setIsAi(true)}
                onMouseLeave={() => setIsAi(false)} className="service-item item-cyan position-relative">
                <div className="icon">
                  {getAiIcon()}
                </div>
                <a href="service-details.html" className="stretched-link">
                  <h3>Artificial Intelligence</h3>
                </a>
                <p>Our AI services leverage advanced machine learning algorithms, natural language processing, and predictive analytics to build solutions that adapt and learn.</p>
              </div>
            </Link>
          </div>

          <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="100">
            <Link to="/service/data-science">
              <div onMouseEnter={() => setIsAnalytics(true)}
                onMouseLeave={() => setIsAnalytics(false)} className="service-item position-relative">
                <div className="icon">
                  {getAnalyticsIcon()}
                </div>
                <a href="service-details.html" className="stretched-link">
                  <h3>Data Science & Analytics</h3>
                </a>
                <p>Our Data Science and Analytics services transform raw data into strategic insights that drive business decisions.</p>
              </div>
            </Link>
          </div>

          <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="100">
            <Link to="/service/software-development">
              <div onMouseEnter={() => setIsSoftware(true)}
                onMouseLeave={() => setIsSoftware(false)} className="service-item item-teal position-relative">
                <div className="icon">
                  {getSoftwareIcon()}
                </div>
                <a href="service-details.html" className="stretched-link">
                  <h3>Software Development</h3>
                </a>
                <p>Our Software Development services include custom web and mobile application development, designed to meet your specific business requirements.</p>
              </div>
            </Link>
          </div>

          <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="100">
            <Link to="/service/ui-ux">
              <div onMouseEnter={() => setIsUiUx(true)}
                onMouseLeave={() => setIsUiUx(false)} className="service-item item-red position-relative">
                <div className="icon">
                  {getUiUxIcon()}
                </div>
                <a href="service-details.html" className="stretched-link">
                  <h3>Innovative Design</h3>
                </a>
                <p>Our UI/UX design services prioritize creating intuitive and engaging user experiences that resonate with your target audience.</p>
              </div>
            </Link>
          </div>

          {/* <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="500">
            <Link to="/service/seo">
              <div onMouseEnter={() => setIsSeo(true)}
                onMouseLeave={() => setIsSeo(false)} className="service-item item-indigo position-relative">
                <div className="icon">
                  {getSeoIcon()}
                </div>
                <a href="service-details.html" className="stretched-link">
                  <h3>Search Engine Optimization</h3>
                </a>
                <p>Our Search Engine Optimization (SEO) services are designed to enhance your online visibility and drive organic traffic to your website.</p>
              </div>
            </Link>
          </div> */}
        </div>
      </div>
    </section>
  )
}

export default ServicesComponent;